import React from "react";
import { IconBadge, ListItem, Text } from "@hubble/web";
import { Body } from "app/_components/components/Text/Body";
import type { CoinMetaDataListItemProps } from "types/prices";

// Define a reusable ListItem component
const CoinMetaDataListItem = ({
  icon,
  label,
  value
}: CoinMetaDataListItemProps) => {
  if (value === "0" || !value) return null;

  return (
    <ListItem
      alignItems="center"
      left={<IconBadge icon={icon} />}
      right={
        <Text.Body ml="auto" marketing size="sm">
          {value}
        </Text.Body>
      }
      size="dense"
      padding="sm"
    >
      <Body size="sm" className="small-desktop:leading-[16px] font-normal">
        {label}
      </Body>
    </ListItem>
  );
};

export default CoinMetaDataListItem;
